<div class="section__wrapper">
  <app-service-ticket-articles-list></app-service-ticket-articles-list>

  <div class="section__content-inline">
    <h2>{{ '+SERVICE_TICKET.ARTICLES_CALL_NOW_TITLE' | translate }}</h2>

    <button
      class="call-btn"
      data-at-call-now-btn
      gtm="onSelect"
      gtmAction="Call now button"
      gtmCategory="ServiceTicket"
      color="primary"
      mat-stroked-button
      (click)="onCallNowClicked()"
    >
      <mat-icon>call</mat-icon>
      <span>{{ '+SERVICE_TICKET.CALL_NOW_BUTTON' | translate }}</span>
    </button>
  </div>
</div>
